import { SectionHeader } from "@/components/ui/SectionHeader";
import { KeyPointsGrid } from "@/components/ui/KeyPointsGrid";

const SECURITY_ITEMS = [
  {
    title: "暗号化通信",
    description:
      "すべての API 通信は TLS で暗号化。セッション Cookie は httpOnly 属性で保護され、機密データは転送中・保存時ともに安全に管理されます。",
  },
  {
    title: "Cookie セッション + 2FA",
    description:
      "JWT ベースの Cookie セッション認証に加え、TOTP による二要素認証を標準搭載。ログイン時の多層防御で、未承認アクセスを確実に遮断します。",
  },
  {
    title: "オンチェーン検証",
    description:
      "Redemption の crypto-payin webhook では、オンチェーンの ERC-20 Transfer を検証（receipt 取得・改ざん耐性チェック）し、不正な通知を排除します。",
  },
  {
    title: "秘密鍵管理",
    description:
      "ステーブルコイン の mint/transfer に使用される秘密鍵は厳格に管理され、外部からのアクセスを遮断。運用上のベストプラクティスに準拠します。",
  },
];

export function MbscSecurity() {
  return (
    <section className="border-t border-border/60 bg-muted/20 px-6 py-20 md:px-12">
      <div className="mx-auto max-w-4xl">
        <SectionHeader
          eyebrow="Security"
          title="セキュリティを、設計の中心に。"
          description="日本円とステーブルコインを扱う金融インフラとして求められる基準を満たすため、
            認証・通信・オンチェーン検証の各レイヤーで堅牢な設計を採用しています。"
        />
        <KeyPointsGrid items={SECURITY_ITEMS} className="mt-12" />
      </div>
    </section>
  );
}
